module.exports = __webpack_public_path__ + "static/img/jj.ff005aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/jj.png
// module id = rO7D
// module chunks = 0